import { QueryCache, QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 0,
      // staleTime: 1000 * 20, // 20 seconds
    }
  },
  queryCache: new QueryCache({
    onError: (error) =>
      console.error(error),
    //   toast.error(`Something went wrong: ${error.message}`),
  }),
})

export default queryClient;